import { useMemo } from 'react';

import { dashboardSidebarMenuConfig } from 'configs';
import { INavItem } from 'models';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { arrayIntersect } from 'utils';

export const useAuthSidebarMenu = (): [INavItem[]] => {
  const initialMenuItems = dashboardSidebarMenuConfig;
  const { userRoles } = useAppSelector(selectCurrentUserInfo);

  const menuItems = initialMenuItems.filter((menu) => {
    return menu.roles.length === 0 || arrayIntersect(userRoles as any[], menu.roles, 'name').length !== 0;
  });

  return useMemo(() => [menuItems], [menuItems]);
};
